import { stitch } from 'keo';
import { Card, CardText } from 'material-ui/Card';
import Mail from 'material-ui/svg-icons/content/drafts';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { Col, Container, Row } from 'react-grid-system';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form/immutable';
import { TextField } from 'redux-form-material-ui';
import { isEmail } from 'validator';

import FormButton from 'components/shared/buttons/FormButton';
import StickyHeader from 'components/shared/StickyHeader';
import { handleFormProps } from 'utils/helpers';

const style = {
    a: {
        color: 'rgb(10, 136, 213)',
        textDecoration: 'none',
    },
    card: { textAlign: 'center' },
    h2: {
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    p: { textAlign: 'center' },
};

const propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    hasSignedUp: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
};

const render = ({
    props: {
        handleSubmit,
        hasSignedUp,
        submitting,
    }
}) => (
    r.div([
        r(StickyHeader, { title: 'Sign Up' }),
        r(Container, { style: { paddingTop: 40 } }, [
            r(Row, [
                r(Col, {
                    offset: { sm: 3 },
                    sm: 6,
                }, [
                    r(Card, { isRendered: hasSignedUp, style: style.card }, [
                        r(CardText, [
                            r(Mail, { color: '#444', style: { height: 55, width: 55 } }),
                            r.h2({ style: { ...style.h2, marginTop: 0 } }, [
                                'Verify Email',
                            ]),
                            r.div([
                                `We just sent you an email. Just follow the link to verify
                                your email address and finish signing up.`
                            ]),
                        ]),
                    ]),
                    r.div({ isRendered: !hasSignedUp }, [
                        r(Card, { style: { ...style.card, padding: '20px 60px 0' } }, [
                            r(CardText, [
                                r.form({ onSubmit: handleSubmit }, [
                                    r.h2({ style: { ...style.h2, margin: 0 } }, [
                                        'Sign Up',
                                    ]),
                                    r(Field, {
                                        component: TextField,
                                        floatingLabelText: 'Email',
                                        fullWidth: true,
                                        name: 'email',
                                    }),
                                    r(Field, {
                                        component: TextField,
                                        floatingLabelText: 'Password',
                                        fullWidth: true,
                                        name: 'password',
                                        type: 'password',
                                    }),
                                    r(Field, {
                                        component: TextField,
                                        floatingLabelText: 'Confirm Password',
                                        fullWidth: true,
                                        name: 'passwordRepeat',
                                        type: 'password',
                                    }),
                                    r.div({ style: { paddingTop: 20, textAlign: 'right' } }, [
                                        r(FormButton, {
                                            label: 'Sign Up',
                                            submitting,
                                        }),
                                    ]),
                                ]),
                            ]),
                        ]),
                        r.p({ style: style.p }, [
                            r(Link, {
                                style: style.a,
                                to: '/login',
                            }, ['Already have an account? Log In.']),
                        ]),
                    ]),
                ]),
            ]),
        ]),
    ])
);

export default reduxForm({
    form: 'login',
    validate: (values) => {
        const errors = {};
        const email = values.get('email', '');
        const password = values.get('password', '');
        const passwordRepeat = values.get('passwordRepeat', '');

        if (!isEmail(email)) {
            errors.email = 'Please enter a valid email.';
        }

        if (password.length < 7) {
            errors.password = 'Password must be at least 8 characters.';
        }

        if (password !== passwordRepeat) {
            errors.passwordRepeat = 'Passwords do not match.';
        }

        return errors;
    },
})(stitch({
    componentWillReceiveProps: handleFormProps,
    propTypes,
    render,
}));



// WEBPACK FOOTER //
// ./src/components/public/SignUp/SignUp.js